class StringUtils {
  isEmpty(value: string | undefined | null): boolean {
    return (value || '').length === 0;
  }

  getInitials(value?: string): string {
    if (!value) {
      return '';
    }
    return value
      .split(' ')
      .map((it) => it[0])
      .join('');
  }

  /**
   * Deterministic, stable accent colour derived from a string (e.g. an author id/name),
   * so the same author always gets the same colour across comment lists.
   */
  colorFromString(value?: string): string {
    const str = value || '';
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
      hash |= 0;
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 42%, 52%)`;
  }
}

export default new StringUtils();
